import React, { useRef, useEffect } from 'react'

import * as S from './styles'

const BaseModal = ({ type, titleVariation, mobile = false, visibility = false, setVisibility = undefined, icon, title, subTitle, children }) => {
  const myElementRef = useRef(null)

  const handleClickOutside = (event) => {
    // clique em uma opção do react-select
    const isOptionClicked = event.target.classList.contains('react-select__option')

    if (myElementRef.current && !myElementRef.current.contains(event.target) && !isOptionClicked) {
      setVisibility(false)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Escape') setVisibility(false)
  }

  useEffect(() => {
    if (visibility) {
      // Adiciona um ouvinte de evento de clique global
      document.addEventListener('click', handleClickOutside)
      window.addEventListener('keydown', handleKeyPress)
      return () => {
        // Remove o ouvinte de evento de clique quando o componente é desmontado
        document.removeEventListener('click', handleClickOutside)
        window.removeEventListener('keydown', handleKeyPress)
      }
    }
  }, [visibility])

  return (
    <>
      {visibility && <S.PreventScroll />}
      <S.ModalWrapper mobile={mobile} isVisible={visibility}>
        <S.ModalContent ref={myElementRef}>
          <S.ModalHeader>
            <S.Icon type={type}>
              {icon}
            </S.Icon>
            <S.Title variation={titleVariation}>{title}</S.Title>
            <S.SubTitle>{subTitle}</S.SubTitle>
          </S.ModalHeader>
          {children}
        </S.ModalContent>
      </S.ModalWrapper>
    </>
  )
}

export default BaseModal
